import { useTranslation } from 'react-i18next'

export function useFormatRole(): (role: string) => string {
  const { t } = useTranslation('nav')
  return (role: string): string => {
    switch (role) {
      case 'evidenx_admin':
        return t('roles.evidenxAdmin')
      case 'org_admin':
        return t('roles.orgAdmin')
      case 'investigator':
        return t('roles.investigator')
      case 'analyst':
        return t('roles.analyst')
      default:
        return role.replace('_', ' ')
    }
  }
}

interface WorkspaceOptions {
  role: string
  isPlatformAdmin: boolean
  orgName: string | null
}

export function buildWorkspaceName({ role, isPlatformAdmin, orgName }: WorkspaceOptions): string {
  if (isPlatformAdmin) return `EvidenX ${role}`
  if (orgName) return `${orgName} ${role}`
  return role
}
